
import { Options } from "vue-class-component";
import Base from "../base/Base.vue";
@Options({
  props: ["room"]
})
export default class RoomCard extends Base {
  room!: any;
}
